export default function scrollToTopSmooth(): void {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}
